jarallax(document.querySelectorAll('.jarallax'));